// extracted by mini-css-extract-plugin
module.exports = {"preview":"_2s5fEwb6660ZzMasEMQkUD","previewBox":"_1i8wxP8IT6bd_L4oodVgOC"};